import styled from 'styled-components/macro';

import FlexContainer from 'components/FlexContainer/FlexContainer';

export const SelectsWrapperStyled = styled(FlexContainer)`
  gap: 8px;
  width: fit-content;
  flex-wrap: wrap;
`;
